import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["placement", "variation"];
import { useTheme } from '@emotion/react';
import { jsx as ___EmotionJSX } from "@emotion/react";

const StylesTippyArrowVariables = (theme, variation) => ({
  size: 10,
  background: variation === 'light' ? theme.color.light.base : theme.color.dark.base,
  borderColor: variation === 'light' ? theme.color.border.base : theme.color.dark.base
}); // Used in conjunction with `tippy.js` within the Tooltip component


const TippyArrow = _ref => {
  let {
    placement = 'top',
    variation = 'light'
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const theme = useTheme();
  return ___EmotionJSX("div", _extends({
    "data-popper-arrow": true,
    css: [placement.startsWith('top') && {
      bottom: 0
    }, placement.startsWith('right') && {
      left: 0
    }, placement.startsWith('bottom') && {
      top: 0
    }, placement.startsWith('left') && {
      right: 0
    }, process.env.NODE_ENV === "production" ? "" : ";label:TippyArrow;"]
  }, rest), ___EmotionJSX("div", {
    css: [{
      width: StylesTippyArrowVariables(theme, variation).size,
      height: StylesTippyArrowVariables(theme, variation).size,
      background: StylesTippyArrowVariables(theme, variation).background,
      border: '1px solid',
      borderColor: StylesTippyArrowVariables(theme, variation).borderColor,
      borderBottomLeftRadius: theme.borderRadius.base / 2,
      borderRight: 0,
      borderTop: 0
    }, placement.startsWith('top') && {
      transform: 'rotate(-45deg)',
      marginBottom: -StylesTippyArrowVariables(theme, variation).size / 2
    }, placement.startsWith('right') && {
      transform: 'rotate(45deg)',
      marginLeft: -StylesTippyArrowVariables(theme, variation).size / 2
    }, placement.startsWith('bottom') && {
      transform: 'rotate(135deg)',
      marginTop: -StylesTippyArrowVariables(theme, variation).size / 2
    }, placement.startsWith('left') && {
      transform: 'rotate(-135deg)',
      marginRight: -StylesTippyArrowVariables(theme, variation).size / 2
    }, process.env.NODE_ENV === "production" ? "" : ";label:TippyArrow;"]
  }));
};

export default TippyArrow;